import React, { Fragment } from "react";
import useStyles from "./styles";
import {
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  IconButton,
  Box
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import LoadingWidget from "Components/widgets/LoadingWidget";

const AdaptiveModal = ({
  loader = false,
  open,
  fullWidth = true,
  size = false,
  showCancel = false,
  showOk = false,
  showSubmit = false,
  showReport = false,
  showTransparentModal = false,
  datePickerInModal = false,
  disabled = false,
  buttonText = {
    okButton: "Ok",
    cancelButton: "Cancel",
    submitButton: "Submit",
    reportButton: "Report"
  },
  title = "",
  body,
  handleClose,
  handleOk,
  extraInfo,
  normal,
  customClass
}) => {
  // size : [false, xs, sm, md, lg, xl]
  const condition = showOk || showSubmit || showReport;
  const classes = useStyles();
  return (
    <Fragment>
      <Dialog
        disableBackdropClick
        disableAutoFocus={true}
        disableEnforceFocus={true}
        className={`${customClass ? customClass : ""} ${showTransparentModal ? `${classes.transparentDialog}  transparent-dialog` : classes.dialog} ${datePickerInModal ? classes.resetIndex : ""}`}
        fullWidth={fullWidth}
        maxWidth={size}
        open={open}
        onClose={handleClose}>
        <DialogTitle className={classes.dialogTitle}>
          <Box
            display="flex"
            justifyContent={normal ? "flex-start" : "space-between"}
            // justifyContent="space-between"
            alignItems="center"
            width="95%"
            className={`${classes.modalTitleBtn}`}>
            <span className={`${classes.titleStyle} title-style`}>{title}</span>
            {extraInfo}
          </Box>
          <IconButton
            data-testid="handleClose"
            size="small"
            aria-label="close"
            className={classes.closeButton}
            onClick={handleClose}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <div>{body}</div>
        </DialogContent>
        {showCancel || condition ? (
          <DialogActions className={classes.dialogActions}>
            {showCancel && (
              <Button onClick={handleClose} color="primary">
                {buttonText.cancelButton}
              </Button>
            )}
            {condition && (
              <Button
                data-testid="handleOk"
                onClick={handleOk}
                color="primary"
                variant="contained"
                disabled={loader || disabled}>
                {loader ? (
                  <LoadingWidget color="white" />
                ) : (
                  (showOk && buttonText.okButton) ||
                  (showSubmit && buttonText.submitButton) ||
                  (showReport && buttonText.reportButton) ||
                  ""
                )}
              </Button>
            )}
          </DialogActions>
        ) : (
          ""
        )}
      </Dialog>
    </Fragment>
  );
};

export default AdaptiveModal;
